import IJobServeAdvanceSearch from '../types/IJobServeAdvanceSearch';

export default {
  accountId: '',
  resultsetPage: '',
  resultsetSize: '',
  sortOrder: '',
  keywords: '',
  county: '',
  country: '',
  timePeriod: '',
  locations: '',
  locationTypes: ['Home', 'Preferred', 'Job'],
  postCode: '',
  industry: 'IT',
  employmentType: 'Any',
  minSalary: 'Any',
  maxSalary: 'Any',
  skills: [],
  skillMatch: 'Any',
  skillLevel: 'Min',
  visaStatus: '',
  securityClearance: [],
  minEducation: '',
  latestJobTitle: '',
  specificDay: '',
} as IJobServeAdvanceSearch;
